export class PeriodoDiaLaboralModel {
  hora: number = 0;
  minutos: number = 0

  constructor() { }
}
